export default __webpack_public_path__ + "images/a7e14e78a91e5e1d4bf274c7d748ccf3-parking.jpg";